import { IconButton as IconButtonMui, IconButtonProps } from "@mui/material";
import classes from "./styles.module.scss";
import clsx from "clsx";

interface Props extends IconButtonProps {
  iconBtnsize?: "xs" | "sm" | "md" | "xl";
}

export const IconButton = ({
  children,
  iconBtnsize = "md",
  className,
  disabled = false,
  ...props
}: Props) => {
  return (
    <IconButtonMui
      disabled={disabled}
      className={clsx(
        classes.iconButton,
        { [classes[iconBtnsize]]: true, [classes.disabled]: disabled },
        className
      )}
      {...props}
    >
      {children}
    </IconButtonMui>
  );
};
